module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pl-1 title grey lighten-4"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs10": "",
      "sm8": ""
    }
  }, _vm._l((_vm.reportChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'primary white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadDashboardBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(chip) + "\n                ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pl-0 pr-1",
    attrs: {
      "xs2": "",
      "sm4": ""
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('v-chip', {
    staticClass: "caption grey white--text",
    class: _vm.isAutoRef ? 'warning white--text' : '',
    attrs: {
      "small": "",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.enableAutoRef()
      }
    }
  }, [_vm._v("AUTO REFRESH")]) : _vm._e(), _vm._v(" "), _c('v-chip', {
    staticClass: "caption grey white--text mr-0",
    class: _vm.enableTrend === true ? 'warning white--text' : '',
    attrs: {
      "small": "",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.EnableTrend()
      }
    }
  }, [_vm._v("TREND")])], 1), _vm._v(" "), (_vm.enableChip === 'Period') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodFrom
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodFrom = $event
      },
      "update:return-value": function($event) {
        _vm.periodFrom = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodFrom),
      callback: function($$v) {
        _vm.dlgPeriodFrom = $$v
      },
      expression: "dlgPeriodFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodFrom.save(_vm.periodFrom)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodTo
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodTo = $event
      },
      "update:return-value": function($event) {
        _vm.periodTo = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodTo),
      callback: function($$v) {
        _vm.dlgPeriodTo = $$v
      },
      expression: "dlgPeriodTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodTo.save(_vm.periodTo)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadDashboardBasedOnPeriod('Period')
      }
    }
  }, [_vm._v("Go")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showUploadImage = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("insert_photo")]), _vm._v(_vm._s('Photos (' + _vm.lDailyUpdateAttach.fileUrls.length + ')'))], 1), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/DailyReport/' + _vm.handy.formatDBDate(_vm.fromDate)
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 accent",
    attrs: {
      "small": "",
      "disabled": !_vm.aDay
    }
  }, [_vm._v("GENERATE REPORT")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_attendance",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pl-2 py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.showAttendanceSummary()
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-1 pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('div', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "large": "",
      "fab": "",
      "color": "blue white--text title"
    },
    on: {
      "click": function($event) {
        return _vm.showAttendanceSummary()
      }
    }
  }, [_vm._v(_vm._s(_vm.lAtt.attAve + '%'))])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(227,108,9,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s((_vm.lAtt.tot_present ? _vm.lAtt.tot_present : 0) + '/' + _vm.lAtt.tot_staff))])], 1), _vm._v(" "), _c('div', [_vm._v("Present")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_wo ? _vm.lAtt.tot_wo : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("WO")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(118,146,60,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_ot ? _vm.lAtt.tot_ot : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Sby/OT")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s((_vm.lAtt.tot_absent || _vm.lAtt.tot_leave) ? (_vm.lAtt.tot_absent + _vm.lAtt.tot_leave) : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Leave/Ab")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1",
    attrs: {
      "color": "rgba(54,96,146,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_pend || 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Pending")])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_attend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_attend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_attendance ? _vm.lReport.remark_attendance : 'NA') + "\n                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Att')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_water",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Management"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pr-0 py-0"
  }, [_c('span', [_vm._v("Water Quality" + _vm._s(!_vm.aDay ? ' (Average)' : ''))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality') : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.watQualHead,
      "items": _vm.watList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality', props.item.param_name) : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality', props.item.param_name)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.param_name + props.item.param_value))]), _vm._v(" "), _vm._l((props.item.waterQualTypeValue), function(watQualVal, i) {
          return _c('td', {
            key: i,
            class: 'pa-2 ' + (watQualVal.val && (watQualVal.val < props.item.std_val_min || watQualVal.val > props.item.std_val_max) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))
          }, [_vm._v("\n                              " + _vm._s(watQualVal.val ? watQualVal.val : '-') + "\n                            ")])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2 pt-0",
    attrs: {
      "xs8": "",
      "sm4": "",
      "mx-auto": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.waterQualParamList,
      "label": "Parameter",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadWaterQualChart()
      }
    },
    model: {
      value: (_vm.waterQualType),
      callback: function($$v) {
        _vm.waterQualType = $$v
      },
      expression: "waterQualType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watqualtrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watqualtrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pr-0 pt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0 pb-0 pt-2 mt-1",
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v("Water Level" + _vm._s(!_vm.aDay ? ' (Average)' : ''))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Level') : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Level')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "210px",
      "padding": "1rem 1rem 1rem 0px"
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watlvl"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvl"
    }
  })])])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "222px"
    },
    attrs: {
      "id": "div_watlvltrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvltrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pr-0 pt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0 pb-0 pt-2 mt-1",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('span', [_vm._v("Water " + _vm._s(!_vm.aDay ? 'Cons. (Total)' : 'Consumption'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, _vm._l((_vm.consumptionChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: (_vm.choosenType === chip ? 'caption primary white--text' : 'caption'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadWaterConsumptionBasedonChip(chip)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(chip) + "\n                              ")])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Cons')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0 pr-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "py-2 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.consumedVal > 0 ? (_vm.consumedVal.toFixed(2) + ' KL') : 'NA'))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "140px",
      "padding": "1rem 1rem 1rem 0px"
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watcons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watcons"
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(!_vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "pt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2"
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', [_c('b', [_vm._v("Water Sources (KL)")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2"
  }, [_c('v-divider')], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b', [_vm._v("SOURCES (KL)")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.domWatList), function(wat, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "py-2 pl-2",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs9": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_type))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-left title",
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_receipt ? wat.water_receipt.toFixed(2) : 0))])])], 1)], 1)
  }), 1)], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-3 pt-0",
    attrs: {
      "xs8": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.waterConsTypeList,
      "label": "Storage",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadWaterConsChart()
      }
    },
    model: {
      value: (_vm.waterConsType),
      callback: function($$v) {
        _vm.waterConsType = $$v
      },
      expression: "waterConsType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_water ? _vm.lReport.remark_water : 'NA') + "\n            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Water')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_power",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Power Management"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n                  Power Consumption" + _vm._s(!_vm.aDay ? ' (Total)' : '') + "\n                ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('v-icon', [_vm._v("pie_chart")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    style: (_vm.$vuetify.breakpoint.smAndUp ? 'min-height: 150px;' : ''),
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "xs6": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_vm._v(_vm._s(_vm.powCons ? _vm.powCons + ' units' : 'NA'))])])], 1), _vm._v(" "), _c('div', [_vm._v("Electricity Board")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "xs6": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_vm._v(_vm._s(_vm.genCons ? _vm.genCons + ' units' : 'NA'))])])], 1), _vm._v(" "), _c('div', [_vm._v("Genset")])])], 1)], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                        TREND\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n                  Diesel Consumption & Level\n                ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading pa-1",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.diCons !== 'NaN' ? _vm.diCons + ' L' : '0 L'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-1"
  }, [_vm._v("Purchased" + _vm._s(!_vm.aDay ? ' (Total)' : ''))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading pa-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.diStock !== 'NaN' ? _vm.diStock + ' L' : '0 L'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-2"
  }, [_vm._v("Stock" + _vm._s(!_vm.aDay ? ' (Average)' : ''))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_dicons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_dicons"
    }
  })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                        TREND\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_diconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_diconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_power ? _vm.lReport.remark_power : 'NA') + "\n            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Power')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Waste Management" + _vm._s(!_vm.aDay ? ' (Total)' : '')), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_waste"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waste"
    }
  })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                TREND\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_wastetrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_wastetrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_sanity",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Hygiene Management / Sanity Checks"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', {
    class: !_vm.aDay ? 'pa-0' : ''
  }, [_c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.aDay) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadSanityChecksMore()
      }
    }
  }, [_vm._v("Click here to see the list for given period")])], 1) : _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.hygCats), function(cat, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'pa-0 mt-1' : 'pa-0',
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text font"
    }, [_vm._v(_vm._s(cat.check_cat))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.hygList.filter(function (rec) { return rec.check_cat === cat.check_cat; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pr-0",
            staticStyle: {
              "width": "400px"
            }
          }, [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remark ? props.item.remark : ''))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Incidents"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', {
    class: !_vm.aDay ? 'pa-0' : ''
  }, [_c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.aDay) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadIncidentMore()
      }
    }
  }, [_vm._v("Click here to see the list for given period")])], 1) : _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.incidentTypes), function(incident, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'pa-0 mt-1' : 'pa-0',
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text font"
    }, [_vm._v(_vm._s(incident))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.incidentList.filter(function (rec) { return rec.incident_type === incident; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "font",
            staticStyle: {
              "width": "315px"
            }
          }, [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', {
            staticClass: "font"
          }, [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : ''))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.metricCat.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Custom Metrics"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.metricCat), function(cat, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "title"
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(cat) + "\n              ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      staticClass: "text-xs-center",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      attrs: {
        "id": 'div_other_' + cat.split(' ').join('_')
      }
    }, [_c('canvas', {
      attrs: {
        "id": 'chart_other_' + cat.split(' ').join('_')
      }
    })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2 primary"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "caption primary--text",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                      TREND\n                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2 primary"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      attrs: {
        "id": 'div_other_trend_' + cat.split(' ').join('_')
      }
    }, [_c('canvas', {
      attrs: {
        "id": 'chart_other_trend_' + cat.split(' ').join('_')
      }
    })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "900px"
    },
    model: {
      value: (_vm.showUploadImage),
      callback: function($$v) {
        _vm.showUploadImage = $$v
      },
      expression: "showUploadImage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_c('div', [_vm._v("Photos "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showUploadImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.photoCatChips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "color": _vm.lDailyUpdateAttach.cat === chip.attach_cat_id ? 'primary white--text' : ''
      },
      on: {
        "click": function($event) {
          return _vm.loadCategoryImage(chip.attach_cat_id)
        }
      }
    }, [_vm._v("  " + _vm._s(chip.attach_cat_name + (_vm.lDailyUpdateAttach.fileUrls ? (_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length ? (' (' + _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length + ')') : '') : '')))])], 1)
  }), _vm._v(" "), _c('v-chip', {
    attrs: {
      "color": _vm.lDailyUpdateAttach.cat === 'All' ? 'primary white--text' : ''
    },
    on: {
      "click": function($event) {
        return _vm.loadCategoryImage('All')
      }
    }
  }, [_vm._v("All (" + _vm._s(_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.length) + ")")])], 2)], 1), _vm._v(" "), _c('v-card-text', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": _vm.config.FILE_URL(file.file_url)
      }
    }, [_c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n                " + _vm._s(file.notes) + "\n              ")]) : _vm._e()])], 1)
  }), 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', [_c('div', {
    staticClass: "pa-2"
  }, [_vm._v("No photos are available.")])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "850px"
    },
    model: {
      value: (_vm.showSummary),
      callback: function($$v) {
        _vm.showSummary = $$v
      },
      expression: "showSummary"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSummary = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.repHeadSm : _vm.repHead,
      "items": _vm.attReport,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.tot_present))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "red--text pa-0"
        }, [_vm._v(_vm._s(props.item.tot_pend))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.qualityTrendOverADay),
      callback: function($$v) {
        _vm.qualityTrendOverADay = $$v
      },
      expression: "qualityTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.qualityTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? '' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.waterQualParamList,
      "hide-details": "",
      "solo": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterQualityOverADay()
      }
    },
    model: {
      value: (_vm.waterQualiltyType),
      callback: function($$v) {
        _vm.waterQualiltyType = $$v
      },
      expression: "waterQualiltyType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, _vm._l((_vm.trendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Quality')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watqualoveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watqualoveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.lvlTrendOverADay),
      callback: function($$v) {
        _vm.lvlTrendOverADay = $$v
      },
      expression: "lvlTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lvlTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.storageNmListWithWaterLvl,
      "item-value": "storage_id",
      "item-text": "storage_nm",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterLevelOverADay()
      }
    },
    model: {
      value: (_vm.selectedStorageNmWithWaterLvl),
      callback: function($$v) {
        _vm.selectedStorageNmWithWaterLvl = $$v
      },
      expression: "selectedStorageNmWithWaterLvl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.trendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Level')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), (_vm.watTankBattery) ? _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [(_vm.watTankBattery > 20) ? _c('v-icon', {
    staticClass: "mt-2",
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "color": "#00d455"
    }
  }, [_vm._v("battery_full")]) : _c('v-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "color": "error"
    }
  }, [_vm._v("battery_alert")])], 1), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.watTankBattery + '%'))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watlvloveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvloveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.consTrendOverADay),
      callback: function($$v) {
        _vm.consTrendOverADay = $$v
      },
      expression: "consTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.consTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.storageNmListWithWaterCons,
      "item-value": "storage_id",
      "item-text": "storage_nm",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterConsOverADay()
      }
    },
    model: {
      value: (_vm.selectedStorageNmWithWaterCons),
      callback: function($$v) {
        _vm.selectedStorageNmWithWaterCons = $$v
      },
      expression: "selectedStorageNmWithWaterCons"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.waterConsTrendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Cons')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watConsoveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watConsoveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.showPowerConstrendOverADay),
      callback: function($$v) {
        _vm.showPowerConstrendOverADay = $$v
      },
      expression: "showPowerConstrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Power cons. breakup\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPowerConstrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powconstrendoveraday"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powconstrendoveraday"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powgensettrendoveraday"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powgensettrendoveraday"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showSanityChecks),
      callback: function($$v) {
        _vm.showSanityChecks = $$v
      },
      expression: "showSanityChecks"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Hygiene Management / Sanity Checks\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSanityChecks = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.lSan), function(item, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'mt-2' : '',
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "pa-2 primary white--text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.sanHeads,
        "items": _vm.sanList.filter(function (rec) { return _vm.handy.formatDate(rec.c_date) === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.check_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "340px"
            }
          }, [_vm._v(_vm._s(props.item.remark ? props.item.remark : '-'))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right",
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showIncident),
      callback: function($$v) {
        _vm.showIncident = $$v
      },
      expression: "showIncident"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Incidents\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showIncident = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.lInc), function(item, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'mt-2' : '',
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "pa-2 primary white--text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.incHeads,
        "items": _vm.lIncident.filter(function (rec) { return _vm.handy.formatDate(rec.created_on) === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.incident_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '')) : ''))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showRemark),
      callback: function($$v) {
        _vm.showRemark = $$v
      },
      expression: "showRemark"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_c('span', [_vm._v(_vm._s(_vm.lReport.remark === 'Att' ? 'Attendance Remarks' : _vm.lReport.remark === 'Power' ? 'Power Remarks' : _vm.lReport.remark === 'Water' ? 'Water Remarks' : ''))]), _vm._v(" "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRemark = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.AttHeads,
      "items": _vm.lReport.remark === 'Att' ? _vm.lReport.AttRemark : _vm.lReport.remark === 'Power' ? _vm.lReport.PowerRemark : _vm.lReport.remark === 'Water' ? _vm.lReport.WaterRemark : '',
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(_vm.handy.formatDate(props.item.c_date)))]), _vm._v(" "), (_vm.lReport.remark === 'Att') ? _c('td', [_vm._v(_vm._s(props.item.remark_attendance ? props.item.remark_attendance : '-'))]) : _vm._e(), _vm._v(" "), (_vm.lReport.remark === 'Power') ? _c('td', [_vm._v(_vm._s(props.item.remark_power ? props.item.remark_power : '-'))]) : _vm._e(), _vm._v(" "), (_vm.lReport.remark === 'Water') ? _c('td', [_vm._v(_vm._s(props.item.remark_water ? props.item.remark_water : '-'))]) : _vm._e()])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5859e1aa","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Facdash.vue
// module id = 836
// module chunks = 37